// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarNavParent_wrap__LPSR1{position:relative}`, "",{"version":3,"sources":["webpack://./src/apps/admin/templates/AppShell/SidebarNavParent/SidebarNavParent.module.scss"],"names":[],"mappings":"AAAA,8BACE,iBAAA","sourcesContent":[".wrap {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SidebarNavParent_wrap__LPSR1`
};
export default ___CSS_LOADER_EXPORT___;
